import { IntegrationRoutes } from '@/repository/tenant';
const {
	GetAllForTenant,
	RemoveActiveForTenant,
	HubspotPipelines,
	HubspotCallStatuses,
	HubspotCallDirections,
	HubspotCallOutcomes,
	HubspotActivityTypes,
	HubspotMeetingOutcomes,
	RefreshHubspotData,
} = IntegrationRoutes;

export default {
	namespaced: true,
	state: {
		all: []
	},
	actions: {
		async index({ commit }) {
			try {
				let res = await GetAllForTenant()
				let integrations = (res.data || [])
				commit('SET_TENANT_INTEGRATIONS', integrations)
				return res;
			}
			catch (error) {
				console.error('Could not get account\'s active integrations.', error);
				throw error;
			}
		},
		async destroy({ state, commit }, integration) {
			try {
				let res = await RemoveActiveForTenant(integration)
				let integrations = state.all.filter(p => p.integration_id != integration)
				commit('SET_TENANT_INTEGRATIONS', integrations)
				return res;
			}
			catch (error) {
				console.error('Could not get remove integration for account.', error);
				throw error;
			}
		},
		async getHubspotPipelines({ commit }) {
			try {
				let res = await HubspotPipelines();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Pipelines.', error);
				throw error;
			}
		},
		async getHubspotCallStatuses({ commit }) {
			try {
				let res = await HubspotCallStatuses();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Call Statuses.', error);
				throw error;
			}
		},
		async getHubspotCallDirections({ commit }) {
			try {
				let res = await HubspotCallDirections();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Call Directions.', error);
				throw error;
			}
		},
		async getHubspotCallOutcomes({ commit }) {
			try {
				let res = await HubspotCallOutcomes();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Call Outcomes.', error);
				throw error;
			}
		},
		async getHubspotActivityTypes({ commit }) {
			try {
				let res = await HubspotActivityTypes();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Call Types.', error);
				throw error;
			}
		},
		async getHubspotMeetingOutcomes({ commit }) {
			try {
				let res = await HubspotMeetingOutcomes();
				return res.data;
			}
			catch (error) {
				console.error('Could not get Hubspot Meeting Outcomes.', error);
				throw error;
			}
		},
		async refreshHubspotData({ commit }, { type, sprint }) {
			try {
				let res = await RefreshHubspotData({ type, sprint });
				return res.data;
			}
			catch (error) {
				console.error('Could not refresh Hubspot Data.', error);
				throw error;
			}
		},
	},
	mutations: {
		SET_TENANT_INTEGRATIONS(state, integrations) {
			state.all = integrations
		}
	}
}
